<template>
  <div class="wrap">
    <div class="search-wrap">
      <el-input
        v-model="title"
        placeholder="搜索推广名称"
        prefix-icon="el-icon-search"
        v-if="!filter"
        class="input-search"
        @keyup.enter.native="getCoach"
      ></el-input>
    </div>
    <el-button
      type="text"
      @click="addDetail(0)"
      style="float: right;color: #434A64;"
      icon="el-icon-circle-plus"
      >添加推广</el-button
    >
    <el-table :data="tableData">
      <el-table-column label="序号" type="index" width="50px"></el-table-column>
      <el-table-column label="标题" prop="title"></el-table-column>
      <el-table-column label="作者" prop="author"></el-table-column>
      <el-table-column label="图片" prop="img"></el-table-column>
      <el-table-column label="内容" prop="text"></el-table-column>
      <el-table-column label="时间" prop="time_h"></el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button
            @click="addDetail(scope.row.id)"
            size="mini"
            type="text"
            >修改</el-button
          >
          <el-button @click="publish(scope.row.id,2)" type="text">发布</el-button>
          <el-button @click="publish(scope.row.id,3)" type="text">取消发布</el-button>
          <el-button @click="publish(scope.row.id,1)" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: false,
      // 检索词
      searchText: "",
      tableData: [],
      // 推广名称
      title: "",
      msgForm: {
        name: "",
        mobile: "",
        coach_id: "",
        good: [],
        tag: []
      },
      type: "add",
      // 分页
      page: 1,
      page_size: 10,
      total: 0
    };
  },
  methods: {
    // 发布、取消发布、删除
    publish(id,type){
      let contentText = ''
      if (type == 2) {
        contentText = '确认发布此推广吗?'
      }else{
        contentText = '确认取消发布此推广吗？'
      }
      this.$confirm(contentText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .get(`/index.php/admin/content/contentDo?coach_id=${id}&do_type=${type}`)
            .then(res => {
              this.$message(res.msg);
              this.getCoach();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 翻页
    handleCurrentChange(v) {
      this.page = v;
      this.getCoach();
    },
    // 设置每页条数
    handleSizeChange(v) {
      this.page_size = v;
      this.getCoach();
    },
    // 获取推广列表
    getCoach() {
      this.$http
        .post("/index.php/admin/content/contentList", { title: this.title,page: this.page, page_size: this.page_size })
        .then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
    },
    // 新增编辑跳转
    addDetail(id) {
      this.$router.push({
        path: "spread/detail",
        query: {
          id: id
        }
      });
    }
  },
  created() {
    this.getCoach();
  }
};
</script>
<style lang="scss" scoped>
.input-wrap {
  display: flex;
  .el-input {
    margin-right: 5px;
  }
}
</style>
